import React, { Fragment, useContext } from 'react';
import { Column, Link, LocaleContext, PageHeader, Row } from 'shared';

import { AdminToolBox } from './adminToolBox/AdminToolBox';
import { AdminToolsWrapper } from './AdminTools.styles';

export const AdminTools = () => {
  const localeContext = useContext(LocaleContext);

  return (
    <Fragment>
      <AdminToolsWrapper className="admin_tools">
        <PageHeader>{localeContext.formatMessage({ id: 'DASHBOARD.HEADER.ADMIN-TOOLS' })}</PageHeader>
        <Row className="admin_tools__row">
          <Column className="admin_tools__column" size={[12, 12, 6]} key="endpoints">
            <Link url="/endpoints" key="endpoints" className="link--tool">
              <AdminToolBox
                nameId="DASHBOARD.HEADER.ENDPOINTS-MANAGEMENT"
                descriptionId="DASHBOARD.DESCRIPTION.ENDPOINTS-MANAGEMENT"
              />
            </Link>
          </Column>
          <Column className="admin_tools__column" size={[12, 12, 6]} key="tpps">
            <Link url="/tpps" key="tpps" className="link--tool">
              <AdminToolBox
                nameId="DASHBOARD.HEADER.TPPS-MANAGEMENT"
                descriptionId="DASHBOARD.DESCRIPTION.TPPS-MANAGEMENT"
              />
            </Link>
          </Column>
          <Column className="admin_tools__column" size={[12, 12, 6]} key="reports">
            <Link url="/reports" key="reports" className="link--tool">
              <AdminToolBox nameId="DASHBOARD.HEADER.REPORTS" descriptionId="DASHBOARD.DESCRIPTION.REPORTS" />
            </Link>
          </Column>
        </Row>
      </AdminToolsWrapper>
    </Fragment>
  );
};
